var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVkDesktopShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M0 5.5v1C0 8 1.6 9 3 9h5c.4 0 1.1.2 2.7 1.3 1 .8 2.2 1.7 2.2 1.7H14V0h-1.1s-1.2.9-2.2 1.7C9.1 2.8 8.4 3 8 3H3C1.6 3 0 4 0 5.5M7.5 12 6.4 9H4l1.3 5c2 0 2.2-.7 2.2-2"
})));
export default SvgVkDesktopShare;